import { render, staticRenderFns } from "./share-entity-dialog-component.vue?vue&type=template&id=9e98485a&scoped=true"
import script from "./share-entity-dialog-component.vue?vue&type=script&lang=ts"
export * from "./share-entity-dialog-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e98485a",
  null
  
)

export default component.exports